import styled from 'styled-components'
import { cyberColors } from '../../../lib/colors'
export const InfoBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin: 10px 0;
`
export const BoxWrapper = styled.div`
  background: #35353f;
  padding: 5px;
  border-radius: 4px;
  max-width: 66.25px;
  height: 34px;
  width: 100%;
  .title {
    color: ${cyberColors.greyText};
    text-transform: uppercase;
    font-size: 10px;
  }
  .content {
    color: ${cyberColors.whiteDark};
    font-size: 12px;
    width: 55px;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 2px;
    white-space: nowrap;
  }
`
